module.exports = "/packs/step2-sp-fddffe8b021c8f6c740f65e66e52e595.png";